"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smallModalWrapper = void 0;
const colors_1 = require("./colors");
exports.smallModalWrapper = {
    width: ['100%', 'auto'],
    '.modal-body': {
        backgroundColor: colors_1.baseColors.white,
    },
};
//# sourceMappingURL=small-modal-wrapper.js.map